export const status = [
  { label: "Pending", value: "Pending" },
  { label: "In Progress", value: "In Progress" },
  { label: "Resolved", value: "Resolved" },
];

export const roles = [
  { label: "Admin", value: 1 },
  { label: "User", value: 0 },
];
